module.exports = __webpack_public_path__ + "media/images/faces/male/23-90f007e17c20cc8348f431c646d6343d.jpg";